import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '../lib/utils';
import { Menu, X } from 'lucide-react';
const navItems = [{
  name: 'Home',
  path: '/'
}, {
  name: 'Experience',
  path: '/experience'
}, {
  name: 'Credentials',
  path: '/credentials'
}, {
  name: 'Services',
  path: '/services'
}, {
  name: 'Contact',
  path: '/contact'
}];
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={cn('fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b border-white/5', isScrolled || location.pathname !== '/' ? 'bg-navy-900/95 backdrop-blur-md py-3' : 'bg-transparent py-6')} data-id="element-299">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-300">
        <Link to="/" className="flex flex-col" data-id="element-301">
          <span className="font-heading font-bold text-xl md:text-2xl tracking-tighter text-white uppercase" data-id="element-302">
            Guy C. Beougher
          </span>
          <span className="text-[10px] tracking-[0.2em] text-gold-500 uppercase hidden md:block" data-id="element-303">
            Executive Command
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-304">
          {navItems.map(item => <Link key={item.name} to={item.path} className={cn('text-sm font-heading uppercase tracking-widest transition-colors hover:text-gold-500 relative py-2', location.pathname === item.path ? 'text-gold-500' : 'text-slate-300')} data-id="element-305">
              {item.name}
              {location.pathname === item.path && <span className="absolute bottom-0 left-0 w-full h-[2px] bg-gold-500 shadow-[0_0_8px_rgba(197,165,90,0.5)]" data-id="element-306" />}
            </Link>)}
          <Link to="/contact" className="ml-4 px-5 py-2 border border-gold-500 text-gold-500 font-heading text-xs uppercase tracking-widest hover:bg-gold-500 hover:text-navy-900 transition-all" data-id="element-307">
            Engage Now
          </Link>
        </nav>

        {/* Mobile Toggle */}
        <button className="md:hidden text-white p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-308">
          {mobileMenuOpen ? <X data-id="element-309" /> : <Menu data-id="element-310" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-navy-900 border-b border-navy-700 p-4 flex flex-col space-y-4 shadow-xl" data-id="element-311">
          {navItems.map(item => <Link key={item.name} to={item.path} className={cn('text-base font-heading uppercase tracking-widest py-2 border-b border-white/5', location.pathname === item.path ? 'text-gold-500' : 'text-slate-300 hover:text-gold-500')} onClick={() => setMobileMenuOpen(false)} data-id="element-312">
              {item.name}
            </Link>)}
        </div>}
    </header>;
}